import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const Dashboard = React.lazy(() => import('../../views/Dashboard'));

const params = [];
const DashboardRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <Dashboard />
      </Layout>
    </RouteParameter>
  );
};

DashboardRoute.propTypes = {};

DashboardRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DashboardRoute);
